<template>
  <div id="explain-page">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold " style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <p class="font-weight-bold text-h5">{{naviVisibleList.findIndex(item => item.text === '故障モード解説') - 1}}. 故障モード解説</p>
      <table>
        <tr>
          <th class="width-30">項目</th>
          <th>解説</th>
        </tr>
        <tr>
          <td class="width-30">ホットスポット</td>
          <td>太陽電池において単一のセルが発熱している状態です。</td>
        </tr>
        <tr>
          <td class="width-30">マルチホットスポット</td>
          <td>太陽電池において複数のセルが発熱している状態です。</td>
        </tr>
        <tr>
          <td class="width-30">クラスタバイパス</td>
          <td>太陽電池においてバイパスダイオードが動作する等し、回路を迂回している状態です。１クラスタにつき太陽電池の1/3が発電していない状態となっておりますが、発電所構成・発電状況により発電への影響度が変化するので注意してください。</td>
        </tr>
        <tr>
          <td class="width-30">モジュール異常</td>
          <td>太陽電池モジュールが発電していない可能性があります。上記クラスタバイパスがすべてのクラスタにおいて発生している等によりパネル全体が発熱している状態です。</td>
        </tr>
        <tr>
          <td class="width-30">ストリング異常</td>
          <td>該当するストリングが発電していない可能性があります。ただし、外部的な影がストリングに影響を及ぼしている状態でも同じような温度分布となってしまうため、影により性能が低下している状態である可能性もあります。</td>
        </tr>
      </table>
      <div class="d-flex justify-start mt-10">
        <p class="font-weight-bold text-h5">故障モードの推定原因解説</p>
      </div>
      <table>
        <tr>
          <th class="width-30">項目</th>
          <th>解説</th>
        </tr>
        <tr>
          <td>植生による不具合</td>
          <td>構内に生えている雑草や木等によって、モジュールに部分的な影が発生することでホットスポット等の異常が見受けられる状態となっております。</td>
        </tr>
        <tr>
          <td>堆積物による不具合</td>
          <td>モジュールガラス面に著しい汚れ（鳥の糞等の表面に付着しているもの）が発生しており、セルの一部を覆っていることによりホットスポット等の異常が見受けられる状態となっております。</td>
        </tr>
      </table>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === '故障モード解説') + 1}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExplainPage",
  props: ['naviList', 'naviVisibleList', 'cropImagePageNum', 'pdfPageNum'],
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
}
table {
  border-collapse: collapse;
}
td{
  height: 100px;
  padding: 8px;
}
.width-30{
  width: 25%;
}
</style>
